import { __awaiter, __generator } from "tslib";
import { Simulate } from 'react-dom/test-utils';
export var createDeprecatedMultiSelectDriver = function (wrapper, isV3) {
    var multiSelect = wrapper.$(isV3 ? '.multi-select-v3' : '.multi-select');
    var optionSelectorName = isV3 ? '.select-v3__option' : '.Select-option';
    var mouseDownOnElement = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var rawElem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isV3) {
                        e.click();
                    }
                    if (!(e.type === 'react')) return [3 /*break*/, 2];
                    return [4 /*yield*/, e.getNative()];
                case 1:
                    rawElem = _a.sent();
                    Simulate.mouseDown(rawElem);
                    return [2 /*return*/, Promise.resolve()];
                case 2: return [2 /*return*/, e.click()];
            }
        });
    }); };
    var focusInput = function () { return __awaiter(void 0, void 0, void 0, function () {
        var elem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isV3) {
                        return [2 /*return*/, multiSelect.$('.select-v3__value-container').click()];
                    }
                    if (!(multiSelect.type === 'react')) return [3 /*break*/, 2];
                    return [4 /*yield*/, multiSelect.$('.Select-input input').getNative()];
                case 1:
                    elem = _a.sent();
                    Simulate.focus(elem);
                    return [3 /*break*/, 3];
                case 2: return [2 /*return*/, multiSelect.$('.Select-input input').click()];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var optionAtIndex = function (index) { return wrapper
        .$$(optionSelectorName)
        .get(index); };
    var optionWithText = function (text) { return wrapper
        .$$(optionSelectorName)
        .filter(function (elemDriver) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, elemDriver.text()];
            case 1: return [2 /*return*/, (_a.sent()).includes(text)];
        }
    }); }); })
        .get(0); };
    return {
        openSelection: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, focusInput()];
        }); }); },
        selectAtIndex: function (index) { return __awaiter(void 0, void 0, void 0, function () {
            var option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        option = optionAtIndex(index);
                        return [2 /*return*/, mouseDownOnElement(option)];
                }
            });
        }); },
        selectByText: function (text) { return __awaiter(void 0, void 0, void 0, function () {
            var option;
            return __generator(this, function (_a) {
                option = optionWithText(text);
                return [2 /*return*/, mouseDownOnElement(option)];
            });
        }); },
        getSelectionTitles: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, multiSelect.$$(optionSelectorName)
                                .map(function (e) { return e.text(); })];
                }
            });
        }); },
        selectByOptionClassName: function (className) { return __awaiter(void 0, void 0, void 0, function () {
            var selector, option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        selector = isV3 ? "." + className + optionSelectorName : optionSelectorName + "." + className;
                        option = multiSelect.$(selector);
                        return [2 /*return*/, mouseDownOnElement(option)];
                }
            });
        }); },
        selectOptionsBySelector: function (sel) { return __awaiter(void 0, void 0, void 0, function () {
            var option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, focusInput()];
                    case 1:
                        _a.sent();
                        option = multiSelect.$(optionSelectorName + " " + sel);
                        return [2 /*return*/, mouseDownOnElement(option)];
                }
            });
        }); },
        getSelectedValues: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, multiSelect.$$(isV3 ? '.select-v3__multi-value__label' : '.Select-value-label')
                        .map(function (i) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, i.text()];
                            case 1: return [2 /*return*/, (_a.sent()).trim()];
                        }
                    }); }); })];
            });
        }); },
        deselectValue: function (index) { return multiSelect.$$(isV3 ? '.select-v3__multi-value__remove' : '.Select-value-icon').get(index).click(); },
        searchItems: function (query) { return multiSelect.$(isV3 ? '.select-v3__input input' : 'input').enterValue(query); },
        noResultsText: function () { return multiSelect.$(isV3 ? '.select-v3__menu-notice--no-options' : '.Select-noresults').text(); },
        noResults: function () { return multiSelect.$(isV3 ? '.select-v3__menu-notice--no-options' : '.Select-noresults').exists(); },
        getPlaceholder: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                selector = isV3 ? '.select-v3__placeholder' : '.Select-placeholder';
                return [2 /*return*/, multiSelect.$(selector).text()];
            });
        }); },
    };
};
//# sourceMappingURL=driver.js.map